import { translate } from 'src/layouts/core-layout/_functions/translate'

export type SiteLogo = {
  src: string
  alt: string
}

type SiteSettings = {
  show_event_site_logo?: boolean
}

const appWindow = (typeof window !== 'undefined' ? window : {}) as Window & {
  SITE_SETTINGS?: SiteSettings
}

const isEventLogoEnabled = Boolean(appWindow.SITE_SETTINGS?.show_event_site_logo)

export function getSiteLogoPd(): SiteLogo {
  return {
    src: isEventLogoEnabled
      ? '/static/_v1/pd/logos/ui-kit/prodoctorov-event-logo.svg'
      : '/static/_v1/pd/logos/ui-kit/prodoctorov-logo.svg',
    alt: translate('ПроДокторов'),
  }
}
